(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1000],{

/***/ 7314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Minus; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { d: "M5 12h14", key: "1ays0h" }]];
const Minus = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("minus", __iconNode);


//# sourceMappingURL=minus.js.map


/***/ }),

/***/ 31012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Plus; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
];
const Plus = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("plus", __iconNode);


//# sourceMappingURL=plus.js.map


/***/ }),

/***/ 93822:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/alternatives/docusign-vs-zoho-sign",
      function () {
        return __webpack_require__(18570);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50369:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43138);





const BlogImgAndTitle = (param)=>{
    let { title , blogImg , imgAlt , authorImg , authorName , dateAndTime  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-full flex flex-col items-center mb-10 md:mb-0",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "bg-white rounded-3xl mb-2 w-full text-left",
                children: /*#__PURE__*/ _jsx("h1", {
                    className: "text-black text-2xl sm:text-3xl md:text-4xl leading-normal",
                    children: title
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "w-full relative flex flex-col items-center",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "w-full relative flex py-4 px-2 bg-white items-center gap-3 mb-10",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "w-[50px] h-[50px] sm:w-[60px] sm:h-[60px]",
                                children: /*#__PURE__*/ _jsx(Image, {
                                    src: "".concat(BASE_ASSETS_URL, "/boloforms-signature/authors/").concat(authorImg),
                                    width: "10",
                                    height: "10",
                                    className: "w-full h-full object-cover rounded-full",
                                    alt: "BoloForms"
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "font-bold text-lg text-gray-800",
                                        children: authorName
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "text-gray-600 text-sm",
                                        children: dateAndTime
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Image, {
                        className: "max-h-[500px] w-auto rounded-2xl",
                        width: 10,
                        height: 10,
                        src: "".concat(BASE_ASSETS_URL, "/boloforms-signature/comparison/").concat(blogImg),
                        alt: imgAlt
                    })
                ]
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (BlogImgAndTitle)));


/***/ }),

/***/ 46591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43138);
/* harmony import */ var _AppContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2208);
/* harmony import */ var _components_Cards_FeatureCards__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7041);
/* harmony import */ var _components_Buttons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46687);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10447);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56475);
/* harmony import */ var react_icons_hi2__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69274);











const StickyLoginCard = (param)=>{
    let { pageProduct ="" , cardWidth ="xs:w-[360px]" , title , description  } = param;
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_AppContext__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z);
    const content = {
        default: {
            title: "Create a free BoloForms account today!",
            description: "Create your free account today and start creating your own digital signature.",
            link: "https://sheetgod.boloforms.com/login?from=".concat(context.globalData.from || "STICKY_CARD")
        },
        approvals: {
            title: "Create a free BoloForms account today!",
            description: "Create your free account today and start creating your approval workflows.",
            link: "https://approval-dashboard.boloforms.com/login?from=".concat(context.globalData.from || "STICKY_CARD")
        },
        signature: {
            title: "Tired of nonsense pricing of DocuSign?",
            description: "Start taking digital signatures with BoloSign and save money.",
            link: "https://signature.boloforms.com/register?from=".concat(context.globalData.from || "STICKY_CARD")
        },
        "timer-proctor": {
            title: "Create a free BoloForms account today!",
            description: "Create your free account today and start creating tests using BoloForms Timer + Proctor.",
            link: "https://dashboard.boloforms.com/login?from=".concat(context.globalData.from || "STICKY_CARD")
        },
        sheetgod: {
            title: "Create a free BoloForms account today!",
            description: "Create your free account today and start enhancing your sheets using BoloForms SheetGod.",
            link: "https://sheetgod.boloforms.com/login?from=".concat(context.globalData.from || "STICKY_CARD")
        },
        taxes: {
            title: "Create a free BoloForms account today!",
            description: "Create your free account today and start creating your own digital signature.",
            link: "https://signature.boloforms.com/login?from=".concat(context.globalData.from || "STICKY_CARD").concat((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_8__/* .createUTMQueryParams */ .T0)({
                utmData_: context.globalData.utmData,
                from: "STICKY_CARD"
            }))
        }
    };
    const contentToDisplay = pageProduct && content[pageProduct] ? content[pageProduct] : content.signature;
    return(//   <div className="max-w-screen-mxl mx-auto">
    //   {
    //     <FeatureCards
    //       cardsData={featuresData}
    //       featuresStyling={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-10`}
    //     />
    //   }
    //   <div className="mt-10 flex justify-center items-center">
    //     <ButtonPrimary buttonText={`All Features`} buttonUrl={`#`} />
    //   </div>
    // </div>
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full ".concat(cardWidth, " mx-auto border border-surface-dark  px-6 pt-7 pb-9 flex flex-col gap-4 text-center justify-center items-center rounded-xl bg-surface"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_4__.BASE_ASSETS_URL, "/boloforms-signature/boloforms-logo.png"),
                className: "w-auto h-auto rounded-full",
                width: 10,
                height: 10,
                alt: "BoloForms"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-2xl",
                        children: title ? title : contentToDisplay.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-gray-600",
                        children: description ? description : contentToDisplay.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: " flex justify-center items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_9__/* .CLMButtonPrimary */ .IS, {
                            buttonText: "Get started for free",
                            buttonUrl: contentToDisplay.link,
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_10__/* .HiArrowLongRight */ .P8b, {})
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (StickyLoginCard);


/***/ }),

/***/ 9961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const ComparisonTable = (param)=>{
    let { tableData  } = param;
    var _tableData_headers, _tableData_rows;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full overflow-x-scroll sm:overflow-x-auto",
        children: [
            (tableData === null || tableData === void 0 ? void 0 : tableData.heading) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "text-2xl font-bold mb-4",
                children: tableData === null || tableData === void 0 ? void 0 : tableData.heading
            }),
            (tableData === null || tableData === void 0 ? void 0 : tableData.subHeading) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-lg mb-4",
                children: tableData === null || tableData === void 0 ? void 0 : tableData.subHeading
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-[500px] sm:w-full bg-white",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tr", {
                            children: tableData === null || tableData === void 0 ? void 0 : (_tableData_headers = tableData.headers) === null || _tableData_headers === void 0 ? void 0 : _tableData_headers.map((header, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                    className: "py-2 px-4 bg-gray-200 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider",
                                    children: header
                                }, index))
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                        children: tableData === null || tableData === void 0 ? void 0 : (_tableData_rows = tableData.rows) === null || _tableData_rows === void 0 ? void 0 : _tableData_rows.map((row, index)=>{
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                className: "text-sm",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        className: "py-2 px-4 border-b border-r border-gray-200 font-semibold",
                                        children: row === null || row === void 0 ? void 0 : row.feature
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        className: "py-2 px-4 border-b border-r border-gray-200",
                                        children: row === null || row === void 0 ? void 0 : row.product1
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        className: "py-2 px-4 border-b border-r border-gray-200",
                                        children: row === null || row === void 0 ? void 0 : row.product2
                                    }),
                                    (row === null || row === void 0 ? void 0 : row.product3) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        className: "py-2 px-4 border-b border-r border-gray-200",
                                        children: row === null || row === void 0 ? void 0 : row.product3
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            (tableData === null || tableData === void 0 ? void 0 : tableData.paragraph) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-lg mt-4",
                children: tableData === null || tableData === void 0 ? void 0 : tableData.paragraph
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ComparisonTable);


/***/ }),

/***/ 52995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43138);




const ProductDescription = (param)=>{
    let { heading , headingBig , paragraphs , image , sections , ulHeading , ulImage , ulData , olHeading , olData , conclusionHeading , conclusionParagraphs  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full",
        children: [
            heading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "font-bold mb-4 ".concat(headingBig ? "text-2xl sm:text-3xl" : "text-2xl"),
                children: heading
            }),
            paragraphs && paragraphs.map((paragraph, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-lg mb-4",
                    children: paragraph
                }, index)),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                className: "relative w-full mb-4 flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/alternatives").concat(image.src),
                        width: "10",
                        height: "10",
                        className: "w-full h-auto object-cover border",
                        alt: image === null || image === void 0 ? void 0 : image.alt
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                        className: "text-center px-6 sm:px-10 text-xs sm:text-sm italic",
                        children: image === null || image === void 0 ? void 0 : image.caption
                    })
                ]
            }),
            sections === null || sections === void 0 ? void 0 : sections.map((section, index)=>{
                var _section_image, _section_image1;
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "mb-4",
                    children: [
                        section.heading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "text-xl font-bold mb-2",
                            children: section.heading
                        }),
                        section.paragraphs && section.paragraphs.map((paragraph, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-lg mb-4",
                                children: paragraph
                            }, index)),
                        section.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                            className: "relative w-full mb-4 flex flex-col gap-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/alternatives").concat(section.image.src),
                                    width: "10",
                                    height: "10",
                                    className: "w-full h-auto object-cover border",
                                    alt: (_section_image = section.image) === null || _section_image === void 0 ? void 0 : _section_image.alt
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                                    className: "text-center px-6 sm:px-10 text-xs sm:text-sm italic",
                                    children: (_section_image1 = section.image) === null || _section_image1 === void 0 ? void 0 : _section_image1.caption
                                })
                            ]
                        })
                    ]
                }, index);
            }),
            ulHeading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "text-xl font-bold mb-2",
                children: ulHeading
            }),
            ulImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                className: "relative w-full mb-4 flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/alternatives").concat(ulImage.src),
                        width: "10",
                        height: "10",
                        className: "w-full h-auto object-cover border",
                        alt: ulImage === null || ulImage === void 0 ? void 0 : ulImage.alt
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                        className: "text-center px-6 sm:px-10 text-xs sm:text-sm italic",
                        children: ulImage === null || ulImage === void 0 ? void 0 : ulImage.caption
                    })
                ]
            }),
            ulData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: "list-disc pl-6 mb-4 text-gray-900",
                children: ulData.map((data, index)=>{
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        className: "text-lg",
                        children: [
                            (data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                                children: [
                                    data.title,
                                    ": "
                                ]
                            }),
                            data === null || data === void 0 ? void 0 : data.description
                        ]
                    }, index);
                })
            }),
            olHeading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "text-xl font-bold mb-2",
                children: olHeading
            }),
            olData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                className: "list-decimal pl-6 mb-4 text-gray-900",
                children: olData.map((data, index)=>{
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        className: "text-lg",
                        children: [
                            (data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                                children: [
                                    data.title,
                                    ": "
                                ]
                            }),
                            data === null || data === void 0 ? void 0 : data.description
                        ]
                    }, index);
                })
            }),
            conclusionHeading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "text-2xl font-bold mb-2",
                children: conclusionHeading
            }),
            conclusionParagraphs && conclusionParagraphs.map((paragraph, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-lg mb-4",
                    children: paragraph
                }, index))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductDescription);


/***/ }),

/***/ 86585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7314);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31012);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



const FaqCard = (param)=>{
    let { faqQuestion , faqAnswer , questionStyling , answerStyling  } = param;
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [height, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isOpen && contentRef.current) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        onClick: ()=>setIsOpen(!isOpen),
        className: "px-8 py-7 transition-all duration-300 border border-surface-dark rounded-2xl",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: "flex justify-between items-center w-full text-left gap-4 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-[20px] leading-[26px] font-semibold",
                        children: faqQuestion
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-purple-600",
                        children: isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            size: 20
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            size: 20
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: contentRef,
                style: {
                    maxHeight: "".concat(height, "px"),
                    overflow: "hidden",
                    transition: "max-height 0.3s ease, opacity 0.3s ease",
                    opacity: isOpen ? 1 : 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: faqAnswer
                    },
                    className: "mt-6 text-gray-700 text-[18px] leading-[26px] font-medium"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FaqCard);


/***/ }),

/***/ 7041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const FeatureCards = (param)=>{
    let { cardsData , cardsStyling =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8",
        children: cardsData.map((card, index)=>{
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col gap-6 border-2 px-6 sm:px-10 pb-10 pt-16 rounded-xl cardBorders transition-all duration-500 ease-in-out border-gray-600 text-center ".concat(card.styling),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center justify-center w-[100px] h-[100px] mx-auto",
                        children: card.icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-5xl lg:text-5xl flex justify-center items-center h-full w-full bg-white rounded-full",
                            children: card.icon
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col gap-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "text-2xl font-bold",
                                children: card.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-xl",
                                children: card.description
                            })
                        ]
                    })
                ]
            }, index);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FeatureCards);


/***/ }),

/***/ 52702:
/***/ (function(module) {

"use strict";
/** @type {import('next').NextConfig} */ 
const nextConfig = {
    reactStrictMode: true,
    productionBrowserSourceMaps: true,
    images: {
        remotePatterns: [
            {
                protocol: "https",
                hostname: "**"
            }
        ],
        unoptimized: true
    },
    trailingSlash: true,
    async redirects () {
        return [
            {
                source: "/workflow-templates/:path*/",
                destination: "/form-templates/",
                permanent: true
            },
            {
                source: "/contracts",
                destination: "/signature/contracts",
                permanent: true
            },
            {
                source: "/signature/lifetime-deal-v2",
                destination: "/signature/lifetime-deal",
                permanent: true
            },
            {
                source: "/signature/lifetime-offer",
                destination: "/signature/lifetime-deal",
                permanent: true
            },
            {
                source: "/signature/lifetime-plan",
                destination: "/signature/lifetime-deal",
                permanent: true
            },
            {
                source: "/signature/lifetime-value-offer",
                destination: "/signature/lifetime-deal",
                permanent: true
            },
            {
                source: "/signature/super-awesome-deal",
                destination: "/signature/lifetime-deal",
                permanent: true
            },
            {
                source: "/signature/super-yearly-awesome-deal",
                destination: "/signature/lifetime-deal",
                permanent: true
            },
            {
                source: "/signature/yearly-awesome-deal",
                destination: "/signature/lifetime-deal",
                permanent: true
            },
            {
                source: "/signature/deals/l/:path*",
                destination: "/signature/pricing",
                permanent: true
            },
            {
                source: "/signature/lifetime-deal",
                destination: "/signature/pricing",
                permanent: true
            },
            {
                source: "/signature/limited-lifetime-deal",
                destination: "/signature/pricing",
                permanent: true
            },
            {
                source: "/signature/super-lifetime-deal",
                destination: "/signature/pricing",
                permanent: true
            },
            {
                source: "/signature/super-lifetime-dealv2",
                destination: "/signature/pricing",
                permanent: true
            },
            {
                source: "/signature/ultimate-lifetime-deal",
                destination: "/signature/pricing",
                permanent: true
            },
            {
                source: "/signature/lifetime-deal",
                destination: "/signature/pricing",
                permanent: true
            },
            {
                source: "/signature/deals/l/:path*",
                destination: "/signature/pricing",
                permanent: true
            }
        ];
    }
};
module.exports = nextConfig;


/***/ }),

/***/ 18570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_StickyLoginCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46591);
/* harmony import */ var _components_BlogImgAndTitle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50369);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43138);
/* harmony import */ var _components_Alternatives_ComparisonTable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9961);
/* harmony import */ var _components_Cards_FaqCard__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86585);
/* harmony import */ var _components_Alternatives_ProductDescription__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52995);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52702);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_10__);




// import ComparisonTable from "../../../components/ComparisonTable";







const intro = {
    Docusign: {
        heading: "Introduction to DocuSign",
        headingBig: true,
        image: {
            src: "/docusign.png",
            caption: "Introduction to DocuSign: Simple to sign, easy to send. Keep your business moving forward from anywhere.",
            alt: "DocuSign introduction banner with the slogan 'Simple to sign, easy to send' on a gradient background."
        },
        paragraphs: [
            "Founded in 2003, DocuSign aims to replace manual, paper-based processes with automated, digital ones. The platform is part of the broader movement towards digital transformation, offering tools to electronically sign, prepare, act on, and manage agreements."
        ]
    },
    ZohoSign: {
        heading: "Introduction to Zoho Sign",
        headingBig: true,
        image: {
            src: "/zohosign.png",
            caption: "Zoho Sign: Secure Document Signing for Indian Businesses",
            alt: "Zoho Sign secure document signing for Indian businesses"
        },
        paragraphs: [
            "Launched as part of Zoho's extensive suite of online productivity tools and SaaS applications, Zoho Sign aims to simplify the process of digital signing and management of documents. It's designed for a wide range of industries including finance, HR, sales, and more."
        ]
    }
};
const keyFeatures = {
    Docusign: {
        heading: "Key Features",
        image: {
            src: "/key-features-docusign.png",
            caption: "Key Features: Electronic Signature, Agreement Workflow, Integration, and Security and Compliance.",
            alt: "Graphic displaying key features: Electronic Signature, Agreement Workflow, Integration, and Security and Compliance"
        },
        paragraphs: [
            "DocuSign is a company known primarily for its e-signature technology, which allows documents to be signed electronically from almost anywhere in the world. Here’s a detailed look at what DocuSign offers and its key features:"
        ],
        olData: [
            {
                title: "Electronic Signature",
                description: "The core feature of DocuSign is its e-signature capability, which is legally binding in most countries. This feature supports almost any device and allows for signing documents in multiple formats, including PDF and Microsoft Word."
            },
            {
                title: "Agreement Workflow",
                description: "Users can automate and streamline the entire contract lifecycle from preparing agreements to signing, acting on, and managing them post-signature."
            },
            {
                title: "Integration",
                description: "DocuSign integrates with a wide range of business systems, including Salesforce, Google, Microsoft, and Apple products, which allows users to work within their existing tools while utilizing DocuSign's capabilities."
            },
            {
                title: "Security and Compliance",
                description: "The platform is designed with strong security measures to protect sensitive information. It complies with e-signature legal standards like ESIGN, UETA, and eIDAS."
            }
        ],
        conclusionHeading: "Market Presence",
        conclusionParagraphs: [
            "DocuSign is a leader in the Digital Transaction Management (DTM) and e-signature industry, used by hundreds of thousands of companies across the globe in various industries. It's known for enhancing business efficiency and reducing costs associated with traditional paper processes.",
            "DocuSign continues to evolve by expanding its capabilities and integrating with other cutting-edge technologies to improve user experiences and extend its market reach."
        ]
    },
    ZohoSign: {
        heading: "Key Features",
        paragraphs: [
            "Zoho Sign is a digital signature service from Zoho Corporation, integrated within the broader suite of Zoho's cloud software applications. It enables businesses and individuals to securely sign, send, and manage legally binding documents electronically. Here's a detailed overview of Zoho Sign and its key features:"
        ],
        image: {
            src: "/key-features-zoho-sign.png",
            caption: "Key Features of Zoho Sign: Digital Signatures, Document Management, Integration, Multi-factor Authentication",
            alt: "Key features of Zoho Sign: Digital signatures, document management, integration, multi-factor authentication"
        },
        olData: [
            {
                title: "Digital Signatures",
                description: "Zoho Sign allows users to sign documents electronically in a secure and legally compliant manner. The signatures are compliant with global laws like the ESIGN Act in the United States and eIDAS in the European Union."
            },
            {
                title: "Document Management",
                description: "Users can send documents for signatures, set signing orders, and receive notifications upon completion. It supports various document formats such as PDF, Word, and others."
            },
            {
                title: "Integration",
                description: "Seamlessly integrates with other Zoho apps like Zoho CRM, Zoho People, and Zoho Recruit, as well as external cloud services like Google Drive, Dropbox, Box, OneDrive, and Office 365. This allows users to work efficiently without leaving their ecosystem."
            },
            {
                title: "Multi-factor Authentication",
                description: "To enhance security, Zoho Sign offers multi-factor authentication for signers, ensuring that the identity of the signer is verified through methods such as OTPs via email or SMS."
            }
        ]
    }
};
const ZohoSignVsDocuSign = {
    heading: "Zoho Sign vs. DocuSign",
    headers: [
        "Feature",
        "DocuSign",
        "Zoho Sign"
    ],
    rows: [
        {
            feature: "Core Features",
            product1: "Electronic signature, advanced workflow management, integrated payments, ID verification",
            product2: "Electronic signature, basic workflow management, multi-factor authentication"
        },
        {
            feature: "Integrations",
            product1: "Extensive: Salesforce, Microsoft, Google, Apple, and more",
            product2: "Good within the Zoho ecosystem and some third-party services like Google Drive and Office 365"
        },
        {
            feature: "User Interface",
            product1: "Comprehensive and professional, suited for complex organizational needs",
            product2: "Straightforward and user-friendly, great for basic to moderate business needs"
        },
        {
            feature: "Security and Compliance",
            product1: "High-level security measures; complies with ESIGN, UETA, and eIDAS regulations",
            product2: "Strong security practices; also complies with ESIGN and eIDAS regulations"
        },
        {
            feature: "Pricing",
            product1: "Personal Plan: $10/month for a single user, Standard Plan: $25/user/month, Business Pro Plan: $40/user/month, Advanced Solutions: Custom pricing",
            product2: "Standard Edition: $10/user/month, Professional Edition: $18/user/month, Enterprise Edition: $30/user/month"
        },
        {
            feature: "Customer Support",
            product1: "Extensive support including live chat, phone, and extensive resource libraries",
            product2: "Support through email, live chat, and an extensive FAQ and help documentation"
        },
        {
            feature: "Ideal For",
            product1: "Large enterprises and businesses that need detailed control over document workflows and enhanced security features",
            product2: "Small to medium businesses or users deeply integrated into the Zoho ecosystem"
        }
    ]
};
const keyPricingDetals = {
    heading: "Key Pricing Details",
    paragraphs: [
        "Both DocuSign and Zoho Sign offer flexible pricing plans to cater to a variety of business needs. However, they differ in terms of free trial offerings and billing options. Heres a breakdown of their pricing structures:"
    ],
    DocuSign: {
        ulHeading: "DocuSign",
        data: [
            {
                title: "Personal",
                description: "$10 per user per month when billed annually, or $15 per month with monthly billing."
            },
            {
                title: "Standard",
                description: "$25 per user per month when billed annually, or $45 per month with monthly billing."
            },
            {
                title: "Business Pro",
                description: "$40 per user per month when billed annually, or $65 per month with monthly billing."
            },
            {
                title: "Enhanced Plans",
                description: "Custom pricing tailored to specific enterprise needs."
            }
        ]
    },
    ZohoSign: {
        ulHeading: "Zoho Sign",
        data: [
            {
                title: "Free",
                description: "Access to basic features."
            },
            {
                title: "Standard",
                description: "$10 per user per month when billed annually, or $12 per month with monthly billing."
            },
            {
                title: "Professional",
                description: "$16 per user per month when billed annually, or $20 per month with monthly billing."
            },
            {
                title: "Enterprise",
                description: "$22 per user per month when billed annually, or $28 per month with monthly billing."
            }
        ]
    },
    conclusionParagraphs: [
        "Notably Zoho Sign offers a free tier of service and a 14-day free trial, whereas DocuSign provides a 1-month free trial."
    ]
};
const whyChooseBolosign = {
    heading: "Why Choose BoloSign?",
    paragraphs: [
        "For small businesses looking for a reliable and affordable eSignature solution, BoloSign stands out as the best choice. It not only meets the essential needs of document management and e-signatures but does so in a way that is tailored to the realities of small business operations. With BoloSign, small businesses can enjoy the benefits of digital transformation, ensuring they remain competitive and agile in a digital-first world."
    ],
    image: {
        src: "/small-business-prefer-bolosign.png",
        caption: "Why Small Businesses Prefer BoloSign: Cost-Effectiveness, Customization, Simplicity and Ease of Use, Customer Support, Security, and Scalability.",
        alt: "Why small businesses prefer BoloSign: cost-effectiveness, customization, simplicity, support, security, scalability."
    },
    ulData: [
        {
            title: "User-Friendly Interface",
            description: "BoloSign is crafted to be intuitive, allowing small business owners and their teams to start using it with minimal training. The straightforward dashboard and easy navigation ensure that managing documents is hassle-free."
        },
        {
            title: "Affordability",
            description: "Cost is a critical factor for small businesses, and BoloSign addresses this by offering one of the most competitive pricing models in the market. It provides essential eSignature functionalities at a fraction of the cost of larger competitors like DocuSign."
        },
        {
            title: "Security and Compliance",
            description: "Security is non-negotiable, and BoloSign ensures that all signatures are legally compliant and secure. It adheres to the latest standards, including GDPR and eIDAS, providing end-to-end encryption and ensuring data integrity with audit trails."
        },
        {
            title: "Integration Capabilities",
            description: "BoloSign seamlessly integrates with popular tools commonly used by small businesses, including CRM systems, productivity tools, and document management systems, enhancing workflow and reducing the need for multiple platforms."
        },
        {
            title: "Customization",
            description: "Recognizing that no two businesses are the same, BoloSign allows users to customize their signature processes. This includes custom branding options, which let businesses maintain their brand identity across all documents."
        },
        {
            title: "Support for Multiple Document Types",
            description: "Whether it's contracts, sales agreements, HR documents, or consent forms, BoloSign supports a variety of document types, making it versatile for all business needs."
        },
        {
            title: "Mobile Accessibility",
            description: "In today’s mobile-first world, BoloSign offers full functionality on mobile devices, enabling business owners and their clients to sign documents from anywhere, at any time, on any device."
        }
    ],
    olHeading: "Pricing",
    olData: [
        {
            title: "Forever Free Plan",
            description: "Ideal for beginners, this plan costs $0/month and includes basic features such as 5 form signatures per month, 2 templates, and audit logs, suitable for small startups."
        },
        {
            title: "Freelancer Plan",
            description: "At $8/month, this plan offers 100 form signatures and submissions per month, along with enhancements like form branding and analytics, making it great for freelancers needing advanced features."
        },
        {
            title: "Team Plan",
            description: "Priced at $40/month, the Team plan supports 500 form signatures per month and offers unlimited documents and templates. It includes tools for team collaboration like user management dashboards and Google Drive integration, perfect for small to medium-sized teams."
        },
        {
            title: "Growing Business Plan",
            description: "For $83/month, this plan provides unlimited form signatures and includes sophisticated features like email branding, integration with various business tools, and advanced customization options for rapidly growing businesses."
        }
    ],
    conclusionParagraphs: [
        "Each plan is designed to scale with your business needs, making BoloSign a flexible and cost-effective choice for managing electronic signatures and document workflows.",
        "For the most accurate and up-to-date information, including specific pricing details and feature updates, visiting the official BoloSign website or directly contacting their sales or support team would be the best approach."
    ]
};
const BolosignVsOthersComparison = {
    heading: "BoloSign over Zoho Sign and DocuSign for small businesses",
    headers: [
        "Feature",
        "BoloSIgn",
        "DocuSign",
        "Zoho Sign"
    ],
    rows: [
        {
            feature: "Target Audience",
            product1: "Small businesses",
            product2: "Large enterprises, various industries",
            product3: "Small to medium businesses"
        },
        {
            feature: "Pricing",
            product1: "Highly affordable, budget-friendly",
            product2: "Higher, tiered pricing for different needs",
            product3: "Affordable but less optimal than BoloSign"
        },
        {
            feature: "User Interface",
            product1: "Simple, intuitive for small business needs",
            product2: "Comprehensive, suited for complex needs",
            product3: "User-friendly but less tailored for small businesses"
        },
        {
            feature: "Integrations",
            product1: "Essential integrations with popular small business tools",
            product2: "Extensive range across multiple platforms",
            product3: "Limited to the Zoho ecosystem, less versatile"
        },
        {
            feature: "Security and Compliance",
            product1: "Robust, adhere to standards like GDPR and eIDAS",
            product2: "Very high, meets global compliance standards",
            product3: "Compliant, but lacks advanced security features of BoloSign"
        },
        {
            feature: "Customization",
            product1: "High customization, including branding options",
            product2: "Extensive customization options",
            product3: "Limited customization compared to BoloSign"
        },
        {
            feature: "Mobile Accessibility",
            product1: "Fully functional on mobile devices",
            product2: "Fully functional on mobile devices",
            product3: "Good but does not match BoloSign’s seamless mobile experience"
        },
        {
            feature: "Ease of Use",
            product1: "Designed for easy adoption and minimal training",
            product2: "Might require training for advanced features",
            product3: "Less straightforward than BoloSign for non-Zoho users"
        },
        {
            feature: "Support for Small Businesses",
            product1: "Specifically tailored support and features for small businesses",
            product2: "Broad support, may not be specific to small business needs",
            product3: "General support, not as focused as BoloSign"
        },
        {
            feature: "Cost-Effectiveness",
            product1: "Exceptional value for the cost",
            product2: "Cost can be a barrier for smaller businesses",
            product3: "Good, but BoloSign offers more for less"
        }
    ]
};
const faqs = [
    {
        id: 1,
        faqQuestion: "What are eSignatures and are they legally binding?",
        faqAnswer: "eSignatures are digital forms of a signature used to consent or approve documents online. They are legally binding in many countries around the world, including the U.S., Europe, and much of Asia, provided they meet certain criteria set out by local eSignature laws such as the ESIGN Act in the U.S. and eIDAS in the EU."
    },
    {
        id: 2,
        faqQuestion: "How do eSignature solutions like BoloSign, DocuSign, and Zoho Sign differ?",
        faqAnswer: "While all these solutions provide the basic functionality of electronic signatures, they differ in their target audience, pricing, integrations, and additional features. For example, DocuSign offers advanced features suitable for large enterprises, Zoho Sign is optimal within the Zoho ecosystem, and BoloSign is tailored for small businesses, emphasizing affordability and ease of use."
    },
    {
        id: 3,
        faqQuestion: "Can eSignature software integrate with other business tools?",
        faqAnswer: "Yes, most eSignature solutions offer integrations with a variety of business tools such as CRM systems, productivity apps, and document management systems. This allows for seamless workflows and reduces the need for manual data entry."
    },
    {
        id: 4,
        faqQuestion: "What security measures should I look for in an eSignature solution?",
        faqAnswer: "Look for features such as SSL encryption, two-factor authentication, compliance with global standards (e.g., GDPR, eIDAS), and audit trails that log the signing process details."
    },
    {
        id: 5,
        faqQuestion: "How does eSignature technology help small businesses?",
        faqAnswer: "eSignature technology helps small businesses by reducing the time and cost associated with manual, paper-based processes. It also enhances customer experience with quick, secure, and convenient document signing, and supports remote business operations."
    }
];
const DocusignVsZohoSign = ()=>{
    var _keyPricingDetals_ZohoSign, _keyPricingDetals_ZohoSign1, _keyPricingDetals_DocuSign, _keyPricingDetals_DocuSign1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full md:mt-20 mt-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Zoho Sign vs DocuSign: Which eSignature Solution is Best?"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Compare Zoho Sign and DocuSign to find the best eSignature solution for your business needs."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: "Boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "publisher",
                        content: "BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "DocuSign, Zoho Sign, DocuSign or Zoho Sign, DocuSign and Zoho Sign, E-Signature Showdown, Electronic Signatures, Digital Workflows, Document Management, E-Signature Comparison, PandaDoc, Comparison"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/signature/alternatives/docusign-vs-zoho-sign/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "Zoho Sign vs DocuSign: Which eSignature Solution is Best?"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/signature/alternatives/docusign-vs-zoho-sign/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "Zoho Sign vs DocuSign: Which eSignature Solution is Best?"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/alternatives/docusign-vs-zoho-sign/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-screen-xl mx-auto flex flex-col mb-20 md:px-8 px-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mx-auto relative w-full h-fit sm:h-[400px] lg:h-[500px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                            className: "w-full h-full sm:h-[400px] lg:h-[500px] object-cover rounded-3xl rounded-b-3xl",
                            src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_6__.BASE_ASSETS_URL, "/v2/alternatives/docusign-vs-zoho-sign.png"),
                            width: 10,
                            height: 10,
                            alt: "DocuSign vs Zoho Sign comparison graphic with logos on a pastel background."
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col gap-y-16 lg:flex-row-reverse justify-between mt-[50px] sm:mt-[100px] lg:gap-12 xxl:gap-40",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "self-center lg:self-start lg:sticky lg:top-[120px]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_StickyLoginCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex-1",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col gap-4",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "font-bold text-3xl sm:text-4xl text-black",
                                                children: "DocuSign vs. Zoho Sign: Making the Right Choice for Your Business"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-lg text-gray-900",
                                                children: "In today's fast-paced business environment, the shift towards digital workflows has made electronic signatures a necessity. Streamlining document processes, saving time, and enhancing security are just a few reasons why businesses turn to e-signature solutions. In this article, we embark on a journey to compare two significant players in the e-signature arena: Zoho Sign and DocuSign. Whether you're a seasoned pro or new to the world of e-signatures, we've got you covered."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "w-full mt-10",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Alternatives_ProductDescription__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                ...intro === null || intro === void 0 ? void 0 : intro.Docusign
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Alternatives_ProductDescription__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                ...keyFeatures === null || keyFeatures === void 0 ? void 0 : keyFeatures.Docusign
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "w-full mt-10",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Alternatives_ProductDescription__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                ...intro === null || intro === void 0 ? void 0 : intro.ZohoSign
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Alternatives_ProductDescription__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                ...keyFeatures === null || keyFeatures === void 0 ? void 0 : keyFeatures.ZohoSign
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-full mt-10",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Alternatives_ComparisonTable__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            tableData: ZohoSignVsDocuSign
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "w-full mt-10",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Alternatives_ProductDescription__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                heading: keyPricingDetals === null || keyPricingDetals === void 0 ? void 0 : keyPricingDetals.heading,
                                                paragraphs: keyPricingDetals === null || keyPricingDetals === void 0 ? void 0 : keyPricingDetals.paragraphs,
                                                ulHeading: keyPricingDetals === null || keyPricingDetals === void 0 ? void 0 : (_keyPricingDetals_ZohoSign = keyPricingDetals.ZohoSign) === null || _keyPricingDetals_ZohoSign === void 0 ? void 0 : _keyPricingDetals_ZohoSign.ulHeading,
                                                ulData: keyPricingDetals === null || keyPricingDetals === void 0 ? void 0 : (_keyPricingDetals_ZohoSign1 = keyPricingDetals.ZohoSign) === null || _keyPricingDetals_ZohoSign1 === void 0 ? void 0 : _keyPricingDetals_ZohoSign1.data
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Alternatives_ProductDescription__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                ulHeading: keyPricingDetals === null || keyPricingDetals === void 0 ? void 0 : (_keyPricingDetals_DocuSign = keyPricingDetals.DocuSign) === null || _keyPricingDetals_DocuSign === void 0 ? void 0 : _keyPricingDetals_DocuSign.ulHeading,
                                                ulData: keyPricingDetals === null || keyPricingDetals === void 0 ? void 0 : (_keyPricingDetals_DocuSign1 = keyPricingDetals.DocuSign) === null || _keyPricingDetals_DocuSign1 === void 0 ? void 0 : _keyPricingDetals_DocuSign1.data,
                                                conclusionParagraphs: keyPricingDetals === null || keyPricingDetals === void 0 ? void 0 : keyPricingDetals.conclusionParagraphs
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "w-full mt-10 flex flex-col gap-6",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Alternatives_ProductDescription__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                        heading: "Choosing the Right E-Signature Solution for Small Business",
                                                        paragraphs: [
                                                            "Choosing between DocuSign and Zoho Sign for your small business depends on factors like feature needs, budget, integration compatibility, ease of use, security, and customer support. Consider a free trial to determine which aligns best with your specific requirements."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Alternatives_ProductDescription__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                        heading: "BoloSign: A Great Choice for Small Business Needs",
                                                        image: {
                                                            src: "/bolosign.png",
                                                            alt: "BoloSign eSignature platform for small businesses, dashboard view with forms and team members.",
                                                            caption: "BoloSign: AI for Smart Contract Management. AI assistant to draft, review, and eSign contracts on autopilot for fastest growing companies."
                                                        },
                                                        conclusionParagraphs: [
                                                            "BoloSign is an eSignature solution tailored specifically for small to medium-sized businesses, focusing on affordability and ease of use without compromising on essential features."
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mt-10",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Alternatives_ProductDescription__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            ...whyChooseBolosign
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mt-10",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Alternatives_ComparisonTable__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            tableData: BolosignVsOthersComparison
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col gap-4 mt-16",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "font-bold text-3xl text-black",
                                                children: "FAQs"
                                            }),
                                            faqs.map((faq, index)=>{
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Cards_FaqCard__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                    faqQuestion: faq === null || faq === void 0 ? void 0 : faq.faqQuestion,
                                                    questionStyling: "text-xl",
                                                    faqAnswer: faq === null || faq === void 0 ? void 0 : faq.faqAnswer,
                                                    answerStyling: "text-lg"
                                                }, index);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col gap-4 mt-16",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "font-bold text-3xl text-black",
                                                children: "Conclusion"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-lg text-gray-900",
                                                children: "The choice of an eSignature solution should align with the specific needs and resources of your business. Whether you opt for BoloSign, DocuSign, or Zoho Sign, the key is to ensure that the solution not only meets your immediate signing needs but also integrates well with your existing business processes and scales with your growth. "
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-lg text-gray-900",
                                                children: "Each platform offers unique advantages, and understanding these can help you make an informed decision that contributes to your business's efficiency and compliance. For small businesses focusing on cost-efficiency and simplicity, BoloSign presents a compelling option, while DocuSign and Zoho Sign might be preferable for larger organizations or those already integrated into respective ecosystems. The right eSignature solution empowers your business to operate more effectively in today’s digital landscape, enhancing both productivity and customer satisfaction."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (DocusignVsZohoSign);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(93822); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);